import SesionService from '@/services/SesionService';

export default {
	name: 'Header',
	components: {},
	props: [],
	data() {
		return {
			user: {}
		};
	},
	created() {
		this.user = SesionService.getUser().Data;
	},
	computed: {},
	mounted() {},
	methods: {}
};
